import { reset, SubmissionError } from 'redux-form';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../index';
import { createSelectOptionsFromSysEnums } from '../../../shared/form-elements/select/index';

const defaultInitialState = {
	isShow: false,
	initialValues: null,
	isEditMode: false
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-form`;
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		formSubmit: formData => (dispatch, getState) => {
			const { initialValues, isEditMode } = getState()[`${namespace}`].pollForm;
			const data = {
				form_url: formData.form_url || '',
				status: (formData.status && formData.status[0] && formData.status[0].value) || null,
				language: (formData.language && formData.language[0] && formData.language[0].value) || null
			};

			const request = http({
				url: isEditMode && initialValues.id ? `${endpoints.POLLS.BASE}/${initialValues.id}` : endpoints.POLLS.BASE,
				method: isEditMode && initialValues.id ? 'put' : 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data
			});

			dispatch(parentActions.toggleProgressBar());

			return request(dispatch).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					dispatch(parentActions.fetchData());
				}

				if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					dispatch(parentActions.toggleProgressBar());

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
		},

		togglePollForm: () => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM });
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			pollForm: {
				...initialState,
				isShow: !state.pollForm.isShow
			}
		}),

		[FORM_SUBMIT_SUCCESS]: state => ({
			...state,
			data: null,
			pollForm: {
				...state.pollForm,
				isShow: false
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			let initialValues = state[`${namespace}`].pollForm.initialValues;
			let langOptions = selectors.getLanguagesList(state);
			let statusOptions = selectors.getStatusesList(state);
			return !initialValues
				? {
					status: [find(statusOptions, { value: 'active' })]
				}
				: {
					...initialValues,
					status: [find(statusOptions, { value: initialValues.status })],
					language: [find(langOptions, { value: initialValues.language })]
				};
		},
		getShouldShowPollForm: state => state[`${namespace}`].pollForm.isShow,
		getPollFormEditMode: state => state[`${namespace}`].pollForm.isEditMode,
		getStatusesList: state => createSelectOptionsFromSysEnums(state.root.lists['poll-statuses']),
		getLanguagesList: state => createSelectOptionsFromSysEnums(state.root.lists['languages'])
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/polls/components/poll-form/index.js